<template>
  <div
    :class="active ? 'is-active' : ''"
    class="dropdown"
    @click="active = !active"
  >
    <div class="dropdown-trigger">
      <button class="button">
        <span>
          <slot name="title">
            Actions
          </slot>
        </span>
        <span class="icon is-small">
          <i class="fa fa-angle-down" />
        </span>
      </button>
    </div>
    <div class="dropdown-menu">
      <div class="dropdown-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',

  data() {
    return {
      active: false
    };
  }
};
</script>
